<template lang="pug">
.v-field.field(:class="{'form-error': field && localErrors && localErrors.length && !field.multiple}")
	template(v-if="field.multiple && field.type !== 'file' && field.type !== 'select' && field.type !== 'check-list'")
		.field__multiple-list
			.field__multiple-list-grid
				template(v-for="(item, index) in localValue" :key="index")
					.field__multiple-list-item.flc
						.field__multiple-list-remove-wrap-mob(v-if="isSm")
							.field__multiple-list-remove-wrap-mob-text(v-if="field.multipleBtnRemoveText") {{field.multipleBtnRemoveText + ' ' + (index + 1)}}
							.field__multiple-list-remove-wrap-mob-text(v-else) {{(index + 1)}}
							button.field__multiple-list-remove(v-if="index + 1 > multipleLimitMin"
									type="button"
									aria-label="Удалить"
									@click="multipleRemove(index)")
								v-svg-icon.field__multiple-list-remove-icon(icon="cross-mob")
						v-field(:field="{...field, multiple: false, label: field.label, placeholder: field.placeholder}"
							v-model="localValue[index]" @update:model-value="handleInputMultiple")
						.field__multiple-list-remove-wrap(v-if="!isSm")
							button.field__multiple-list-remove(v-if="index + 1 > multipleLimitMin"
									type="button"
									aria-label="Удалить"
									@click="multipleRemove(index)")
								v-svg-icon.field__multiple-list-remove-icon(icon="cross")
		button.field__multiple-list-add.btn.btn--white(v-if="!localValue || !field.multipleLimi || localValue.length < field.multipleLimit"
				type="button"
				@click="multipleAdd")
			.field__multiple-list-add-text {{field.multipleBtnAddText || "Добавить"}}
			v-svg-icon.field__multiple-list-add-icon(icon="multiple-list-icon")

	template(v-else)
		template(v-if="field.type === 'checkbox'")
			v-field-checkbox(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'check-list'")
			v-field-check-list(:field="field" :model-value="localValue" @update:model-value="handleInput")

		template(v-else-if="field.type === 'radio-list'")
			v-field-check-list(:field="field" radio :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'select' && !field.multiple")
		//-	v-field-select(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'select' && field.multiple")
		//-	v-field-multi-select(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'select-2' && !field.multiple")
		//-	v-field-select-2(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'list'")
		//-	v-field-list(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'lists'")
		//-	v-favorite-lists(:field="field" :model-value="localValue" @update:model-value="handleInput" @add-new-favorite-list="emitAddNewFavoriteList")

		//-template(v-else-if="field.type === 'page-select'")
		//-	v-page-select(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'sort'")
		//-	v-field-sort(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'currency'")
		//-	v-field-currency(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'tumbler'")
		//-	v-field-tumbler(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'tumbler-2'")
		//-	v-field-tumbler-2(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'tumbler-list'")
		//-	v-field-tumbler-list(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'count'")
		//-	v-field-count(:field="field" :model-value="localValue" @update:model-value="handleInput" @start-change="emitStartChange")

		//-template(v-else-if="field.type === 'range'")
		//-	v-field-range(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'toggler'")
		//-	v-field-toggler(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'range-slider'")
		//-	v-field-range-slider(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'rating'")
		//-	v-rating(:field="field" v-model="localValue" @update:model-value="handleInput" input)

		//-template(v-else-if="field.type === 'rate'")
		//-	v-field-rate(:field="field" v-model="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'file'")
		//-	v-field-file(:field="field" @fileinput="fileInput" @fileremove="fileRemove")

		//-template(v-else-if="field.type === 'avatar'")
		//-	v-field-avatar(:field="field" @fileinput="fileInput" @fileremove="fileRemove")

		//-template(v-else-if="field.type === 'date'")
		//-	v-datepicker(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'tel2'")
		//-	v-field-tel(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'code'")
		//-	v-field-code(:field="field" :model-value="localValue" @update:model-value="handleInput")

		//-template(v-else-if="field.type === 'promocode'")
		//-	v-field-promocode(:field="field" :model-value="localValue" :disabled="field.disabled" @update:model-value="handleInput")

		template(v-else)
			v-field-text(:field="field" :model-value="localValue" :disabled="field.disabled" @update:model-value="handleInput")

		template(v-if="Array.isArray(localErrors) && localErrors && localErrors.length")
			template(v-for="error in localErrors")
				.field__errors.flc
					template(v-if="Array.isArray(error.message) && error.message.length")
						.field__error.flc(v-for="errorItem in error.message" v-html="errorItem")
					template(v-else)
						.field__error.flc(v-html="error.message")
</template>

<script>
import controller from '../scripts/controller/controller';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		isMobMixin
	],

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		errors: {
			type: Array,
			default: null,
		},

		modelValue: {
			type: [Object, String, Number, Boolean, Date],
			default: null
		},

		multipleBtnRemoveText: {
			type: String,
			default: null
		}
	},

	emits: [
		'add-new-favorite-list',
		'start-change',
		'fileinput',
		'fileremove',
		'update:model-value'
	],


	data() {
		return {
			localValue: null,
			localErrors: null,
			touch: controller.touch
		};
	},

	// created() {
	// 	if (this.field.multiple && (!this.localValue || !Array.isArray(this.localValue) || !this.localValue.length)) {
	// 		this.localValue = [null];
	//
	// 	}
	// },

	computed: {
		multipleLimitMin() {
			let limit = this.field && this.field.multipleLimitMin;
			return isNaN(limit) ? 1 : limit;
		}
	},

	watch: {
		modelValue: {
			immediate: true,
			handler() {
				this.updateLocalValue();
			}
		},

		field: {
			immediate: true,
			handler() {
				this.localErrors = this.errors;
			}
		}
	},

	methods: {
		emitAddNewFavoriteList() {
			this.$emit('add-new-favorite-list');
		},

		emitStartChange() {
			this.$emit('start-change');
		},

		fileInput(e) {
			this.$emit('fileinput', e);
		},

		fileRemove(e) {
			this.$emit('fileremove', e);
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		multipleAdd() {
			if (!Array.isArray(this.localValue)) {
				this.localValue = [];
			}
			if (!this.field.multipleLimit || this.localValue.length < this.field.multipleLimit) {
				this.localValue.push(null);
			}
		},

		multipleRemove(index) {
			this.localValue.splice(index, 1);
			if (Array.isArray(this.localErrors)) {
				this.localErrors.splice(index, 1);
			}
			this.handleInputMultiple();
		},

		handleInputMultiple(){
			this.$emit('update:model-value', this.localValue, this.field);
		},

		handleInput(value) {
			this.localValue = value;
			this.$emit('update:model-value', this.localValue, this.field);
		}
	}
};
</script>
